if (typeof DiscountProgressBar !== "function") {
  class DiscountProgressBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold);
      this.messageBase =
        this.dataset.messageBase || "Save 20% on orders $200+";
      this.messageEmpty =
        this.dataset.messageEmpty ||
        "Add {remaining} to your cart and {message} on orders {threshold}+";
      this.messageInProgress =
        this.dataset.messageInProgress || "Add {remaining} to your cart and {message}";
      this.termsEnabled = this.dataset.termsEnabled === "true";
      this.termsPage = this.dataset.termsPage;
      this.progressBar = this.querySelector(".progress-bar");
      this.progressBarRow = this.querySelector(".progress-bar-row");
      this.progressFill = this.querySelector(".progress-fill");
      this.thresholdMessage = this.querySelector(".threshold-reached-message");
      this.progressBarTotal = this.querySelector(".progress-bar-total");
      this.progressUnderText = this.querySelector(".progress-under-text");

      if (this.progressBarTotal) {
        this.progressBarTotal.textContent = `$${(this.threshold / 100).toFixed(
          0
        )}`;
      }

      // Initial update
      this.updateProgress();

      // Listen for cart updates
      document.addEventListener("cart-updated", () => {
        this.updateProgress();
      });
      document.addEventListener("add-to-cart", () => {
        this.updateProgress();
      });

      this.setupCartObserver();
    }

    updateProgress() {
      const cartTotalEl = document.querySelector(
        ".cart__total-original[data-cart-total-original]"
      );
      // Remove $ and parse to float, then convert to cents
      const cartTotalText = cartTotalEl
        ? cartTotalEl.textContent.replace(/[^0-9.]/g, "")
        : "0";
      const cartTotal = Math.round(parseFloat(cartTotalText) * 100) || 0;

      const remaining = this.threshold - cartTotal;
      const width = Math.min((cartTotal / this.threshold) * 100, 100);
      const thresholdText = `$${(this.threshold / 100).toFixed(0)}`;
      const remainingText = `$${(remaining / 100).toFixed(0)}`;
      const formatMessage = (template) =>
        template
          .replace("{remaining}", remainingText)
          .replace("{threshold}", thresholdText)
          .replace("{message}", this.messageBase);

      if (remaining > 0) {
        if (this.classList.contains("success")) this.classList.remove("success");
        // Show progress
        if (this.progressBarRow) {
          this.progressBarRow.style.display = "flex";
        } else if (this.progressBar) {
          this.progressBar.style.display = "block";
        }
        this.thresholdMessage.style.display = "none";
        if (this.progressUnderText) {
          this.progressUnderText.style.display = "block";
        }
        

        if (this.progressUnderText) {
          let template = this.messageInProgress;
          if (cartTotal === 0) {
            template = this.messageEmpty;
          }
          this.progressUnderText.textContent = formatMessage(template);
          if (this.termsEnabled && this.termsPage) {
            const link = document.createElement("a");
            link.href = `#trigger:guide:/pages/${this.termsPage}`;
            link.textContent = "ⓘ";
            link.className = "progress-terms-link";
            this.progressUnderText.append(" ", link);
          }
        }
        if (this.progressFill) {
          this.progressFill.style.width = `${width}%`;
        }
      } else {
        // Hide progress, show message
        if (this.progressBarRow) {
          this.progressBarRow.style.display = "none";
        } else if (this.progressBar) {
          this.progressBar.style.display = "none";
        }
        this.thresholdMessage.style.display = "block";
        if (this.progressUnderText) {
          this.progressUnderText.style.display = "none";
        }
        if (!this.classList.contains("success")) this.classList.add("success");
      }
    }

    setupCartObserver() {
      const attachTo = (el) => {
        if (!el) return;
        if (this.cartObserver) this.cartObserver.disconnect();
        this.cartObserver = new MutationObserver(() => this.updateProgress());
        this.cartObserver.observe(el, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      };

      const initialEl = document.querySelector(
        ".cart__total-original[data-cart-total-original]"
      );
      if (initialEl) {
        attachTo(initialEl);
        return;
      }

      const finder = new MutationObserver(() => {
        const el = document.querySelector(
          ".cart__total-original[data-cart-total-original]"
        );
        if (el) {
          attachTo(el);
          finder.disconnect();
        }
      });
      finder.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  customElements.define("discount-progress-bar", DiscountProgressBar);
}
